import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { links } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


class SeveralQueueItemsNotification extends PureComponent {

  static contextTypes = {
    close: PropTypes.func,
  }

  static propTypes = {
    onClose: PropTypes.func,
    itemsCount: PropTypes.number,
  }

  handleClick = () => {
    const { close } = this.context
    const { onClose } = this.props

    close()

    actions.models.router.push(links.queue)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { itemsCount } = this.props

    return (
      <div onClick={this.handleClick}>
        <Box pt="36" pb="36" relative>
          <Text
            size="14-24"
            message={messages.text}
            values={{ itemsCount }}
            semibold
            align="center"
            uppercase
          />
        </Box>
      </div>
    )
  }
}


export default SeveralQueueItemsNotification
